import schedulerActions from 'modules/Scheduler/Scheduler.actions';

const initialState = {
  list: [],
  data: {},
  fetching: false,
  creating: false,
  deleting: false,
  editing: false,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case schedulerActions.FTCHING:
      return {
        ...state,
        fetching: true,
        editing: false,
        deleting: false,
        error: null,
      };

    case schedulerActions.CREATING:
      return {
        ...state,
        fetching: false,
        creating: true,
        editing: false,
        deleting: false,
        error: null,
      };

    case schedulerActions.FETCH_SUCCESS:
      return {
        ...state,
        list: action.payload,
        fetching: false,
        editing: false,
        deleting: false,
        error: null,
      };

    case schedulerActions.CREATING_SUCCESS:
      return {
        ...state,
        fetching: false,
        creating: false,
        editing: false,
        deleting: false,
        error: null,
      };

    case schedulerActions.ERROR:
      return {
        ...state,
        fetching: false,
        editing: false,
        deleting: false,
        error: action.payload,
      };

    case schedulerActions.DELETING:
      return {
        ...state,
        deleting: true,
        error: null,
      };
    case schedulerActions.DELETE_SUCCESS:
      return {
        ...state,
        // list: [...state.list, ...action.payload],
        fetching: false,
        editing: false,
        deleting: false,
        error: null,
      };
    case schedulerActions.UPDATING:
      return {
        ...state,
        fetching: false,
        editing: true,
        deleting: false,
        error: null,
      };
    case schedulerActions.UPDATING_SUCCESS:
      return {
        ...state,
        // list: [...state.list, ...action.payload],
        fetching: false,
        editing: false,
        deleting: false,
        error: null,
      };

    default:
      return { ...state };
  }
};
export default reducer;
